import { useCallback, useEffect, useState } from 'react'
import { ILot } from '../types/lot'
import { List } from '../components/Lots'
import { lot as lotAPI, user as userAPI } from '../utils/api/index'
import { IUser } from '../types/user'
import { UserList } from '../components/Users'
import { ISelectOption, Select } from '../components/UI/Select'
import { EventContext } from '../ctx/event'
import { TRow } from '../types/api'
import { Pagination } from '../hoc/Pagination'
import { TopLotsCarousel } from '../components/Carousel'
import { OGSetDescription, OGSetTitle, OGUpdateUrl } from '../utils/openGraph'
import { Margin } from '../hoc/Margin'
import { Container, ContainerTitle } from '../components/Container'
import { useTypedSelector } from '../hooks/useTypedSelector'
import { useDispatch } from 'react-redux'
import { mainSetLoading } from '../store/actions/main'

export const Index = () => {
    const [row, setRow] = useState<TRow<ILot>>()
    const [lots, setLots] = useState<ILot[]>([])
    const [top, setTop] = useState<ILot[]>([])
    const [users, setUsers] = useState<IUser[]>([])
    const [page, setPage] = useState(1)

    const { main } = useTypedSelector((s) => s)
    const dispatch = useDispatch()

    const sortOptions: ISelectOption[] = [
        {
            label: 'Recently added',
            value: '1',
            desc: true,
            orderBy: 'createdAt',
        },
        {
            label: 'Recently active',
            value: '4',
            desc: false,
            orderBy: 'lastBetAt',
        },
        {
            label: 'Highest price',
            value: '2',
            desc: true,
            orderBy: 'currentCost',
        },
        {
            label: 'Lowest price',
            value: '3',
            desc: false,
            orderBy: 'currentCost',
        },
    ]
    const [sort, setSort] = useState<ISelectOption>(sortOptions[0])

    const getLots = useCallback(async () => {
        dispatch(mainSetLoading(true))
        await lotAPI
            .get({
                sortBy: sort.orderBy as
                    | 'lastBetAt'
                    | 'createdAt'
                    | 'updatedAt'
                    | 'currentCost',
                sortDesc: sort.desc,
            })
            .then(({ data }) => {
                setRow(data)
                setLots(data.rows)
            })
            .catch((err) => console.log(err))
        dispatch(mainSetLoading(false))
    }, [sort, dispatch])

    useEffect(() => {
        setPage(1)
        getLots()
    }, [sort, getLots])

    async function getTop() {
        await lotAPI.top().then(({ data }) => setTop(data))
    }

    async function addLots() {
        setPage(page + 1)
        await lotAPI
            .get({
                sortBy: sort.orderBy as
                    | 'lastBetAt'
                    | 'createdAt'
                    | 'updatedAt'
                    | 'currentCost',
                sortDesc: sort.desc,
                page: page + 1,
            })
            .then(({ data }) => {
                setRow(data)
                setLots([...lots, ...data.rows])
            })
    }

    async function changeLot(lot: ILot) {
        const updatedLots = lots.map((l) => {
            return l.id === lot.id ? lot : l
        })
        setLots(updatedLots)
    }

    function removeLot(id: string) {
        setLots(lots.filter((l) => l.id !== id))
    }

    useEffect(() => {
        OGSetTitle('Caliente: The NFT platform for adults.')
        OGSetDescription(
            'Caliente is the NFT platform, focused on amateur adult content creators, and them earning the most by using blockchain technology. We are a place where they can feel safe and make money off their original content.'
        )
        OGUpdateUrl()
        getTop()
        userAPI.featured().then(({ data }) => setUsers(data))
    }, [])

    function changeFollowing(user: IUser) {
        setUsers((oldUsers) => {
            const filteredUsers = oldUsers.filter((u) => u.id !== user.id)
            return [...filteredUsers, user]
        })
    }

    return (
        <Container>
            <EventContext.Provider
                value={{
                    onPaginationPage: addLots,
                    onTimerEnd: removeLot,
                    onTimerUpdated: changeLot,
                    onFollowed: changeFollowing,
                }}
            >
                <Margin margin={{ bottom: 20 }}>
                    {!!lots.length ? (
                        <TopLotsCarousel Lots={top}></TopLotsCarousel>
                    ) : null}
                </Margin>
                <div className="selects selects_margin">
                    <div className="selects__item">
                        <Select
                            title="Filters:"
                            state={[sort, setSort]}
                            options={sortOptions}
                            preset="select-text"
                        ></Select>
                    </div>
                </div>
                {row ? (
                    <Pagination row={row} length={lots.length}>
                        <List lots={lots}></List>
                    </Pagination>
                ) : null}

                {!main.loading && !row?.rows.length ? (
                    <div className="empty">Nothing here yet</div>
                ) : null}
                {users ? (
                    <>
                        <ContainerTitle title="Featured creators" />
                        <UserList users={users}></UserList>
                    </>
                ) : null}
            </EventContext.Provider>
        </Container>
    )
}
